import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//App
import {
  LookupGroupContextData,
  LookupGroupFormProps,
} from "../../../../types/lookupGroup";
import { LookupGroupContext } from "./LookupGroupContainer";
import { EMPTY_GUID } from "../../../../utility/constants";

//Common
import FormBackGround from "../../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../../common/Forms/FormHeader/FormHeader";
import TextField from "../../../common/VFX-UI/TextField/TextField";
import ActionBar from "../../../common/ActionBar/ActionBar";
import AutoComplete from "../../../common/VFX-UI/Autocomplete/Autocomplete";
import { Container } from "reactstrap";
import { Chip } from "../../../common/VFX-UI";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  lookupTypeId: Yup.array()
    .min(1, "Lookup Type is required")
    .required("Lookup Type is required"),
  sortValue: Yup.number().min(0, "Must be positive number"),
});

const LookupGroupForm = (props: LookupGroupFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);

  const lookupGroupContext = useContext<LookupGroupContextData | null>(
    LookupGroupContext
  );

  const { id, lookupTypeId } = initialVal;
  const title = id === EMPTY_GUID ? "New Lookup Group" : "Edit Lookup Group";

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Container>
            <Form noValidate>
              <div className="d-flex justify-content-end mb-3 me-3">
                <Chip label={values.isActive ? "Active" : "Inactive"} />
              </div>
              <TextField
                label="Name"
                type="text"
                name="name"
                isRequired={true}
              />
              <TextField
                label="Description"
                type="textarea"
                name="description"
                isRequired={true}
              />
              <AutoComplete
                disabled={true}
                name="lookupTypeId"
                label="Lookup Type"
                isRequired={true}
                options={lookupGroupContext?.lookupTypes ?? []}
                defaultSelected={
                  lookupTypeId != null && lookupTypeId.length > 0
                    ? [lookupTypeId[0]]
                    : []
                }
              />
              <TextField label="Display Order" type="number" name="sortValue" />
              <ActionBar
                submitHandler={saveInput}
                cancelHandler={onClose}
                submitText="Submit"
                cancelText="Cancel"
                isLoading={status === "pending"}
              ></ActionBar>
            </Form>
          </Container>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default LookupGroupForm;
